import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { authService } from '@/services/auth';
import type { User } from '@/types';
import { AuthContext } from '@/context/auth-context';

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(() => authService.bootstrap());

  const login = useCallback((u: User) => {
    authService.setUser(u);
    setUser(u);
  }, []);

  const logout = useCallback(() => {
    authService.clearUser();
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({
      user,
      isAuthenticated: user !== null,
      isOperator: user?.role === 'operator',
      login,
      logout,
    }),
    [user, login, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
